import { Utils } from 'src/app/core/utils/utils';
import { ActivatedRoute } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-error',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.scss']
})
export class ErrorComponent implements OnInit {

  numError: string = "1";
  authError: string | undefined;
  titulo: string = "";
  texto: string = "";
  textoAux: string | null = null;
  literalTitle: string = "PAGEERROR.title_";
  literalText: string = "PAGEERROR.text_";

  constructor(private route: ActivatedRoute,
              private translateService: TranslateService) { }

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
        console.log(params);

        this.numError = params.numError ?? '1';
        this.authError = params.detallErrAuth;
        this.setTextos();
      });
  }

  private setTextos() {
    if (this.numError == '2' || this.numError == '3' || this.numError == '4')
      this.numError = '1';
      this.titulo = this.literalTitle + this.numError;
      this.textoAux = null;
      this.texto = this.literalText + this.numError;
    if (Utils.noUndfAndNull(this.authError))
      this.textoAux = "PAGEERROR.error_auth";
      switch (this.numError) {
        //Error 1: No se ha recibido en página valid el id o la carpeta
        case '1':
          this.titulo = this.translateService.instant('ACCESO.ERROR_AUTENT.cabecera');
          this.texto = this.translateService.instant('ACCESO.ERROR_AUTENT.error1');
        break;
        //Error 2: Al solicitar los datos del login Valid no se ha recibido nada y tampoco peta
        case '2':
          this.titulo = this.translateService.instant('ACCESO.ERROR_AUTENT.cabecera');
          this.texto = this.translateService.instant('ACCESO.ERROR_AUTENT.error2');
        break;
        //Error 3: Al solicitar los datos del login Valid devuelve un KO
        case '3':
          this.titulo = this.translateService.instant('ACCESO.ERROR_AUTENT.cabecera');
          this.texto = this.translateService.instant('ACCESO.ERROR_AUTENT.error3');
        break;
        //Error 4: Al solicitar los datos del login Valid peta
        case '4':
          this.titulo = this.translateService.instant('ACCESO.ERROR_AUTENT.cabecera');
          this.texto = this.translateService.instant('ACCESO.ERROR_AUTENT.error4');
        break;
        default:
        break;
     }
  }

}
